<template>

    <div class="input-container">

        <label v-if="label" :class="classLabel">{{ label }}</label>

        <div class="input-group mb-0 bg-light-subtle rounded-3">

            <span class="input-group-text text-muted" v-if="icon">
                <i :class="icon"></i>
            </span>

            <div class="flex-1">
                <MultiSelect
                    :required="required"
                    v-model="selected"
                    :options="options"
                    :label="labelOption"
                    :track-by="labelOption"
                    :valueProp="valueProp"
                    searchable
                    :mode="getMode()"
                    :placeholder="placeHolder"
                    noResultsText="Nenhuma opção encontrada"
                    :hideSelected="false"
                    :object="false"
                    :closeOnSelect="!multiple"
                    :closeOnDeselect="!multiple"
                    @update:modelValue="updateModelValue"
                    appendToBody
                    :canClear="canClear"
                >
                    <template v-slot:multiplelabel="{ values }">
                        <div class="multiselect-multiple-label">
                            {{ values.map(item => item[labelOption]).join(', ') }}
                        </div>
                    </template>
                </MultiSelect>
            </div>

        </div>

    </div>

</template>

<script>
export default {
    props: {
        label: {
            type: String
        },
        classLabel:{
            type: String,
            default: 'form-label'
        },
        valueProp: {
            type: String
        },
        labelOption: {
            type: String
        },
        icon: {
            type: String,
        },
        placeHolder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        canClear: {
            type: Boolean,
            default: true,
        },
        modelValue: {
            default: ''
        },
        options:{
            type: Array
        }
    },
    data() {
        return {
            senhaVisivel: false,
            selected: this.modelValue
        };
    },
    computed: {
        inputType() {
            if (this.type === 'password') {
                return this.senhaVisivel ? 'text' : 'password';
            }
            return this.type;
        }
    },
    methods: {
        updateModelValue(newValue) {
            this.selected = newValue;
            this.$emit('update:modelValue', newValue); // Atualiza o valor do props no componente pai
        }, 
        getMode(){
            return (this.multiple) ? 'multiple' : 'single';
        }
    },
    watch: {
        modelValue(newVal) {
            this.selected = newVal;
        },
        selected(newVal) {
            this.$emit('update:modelValue', newVal); // Emite a alteração quando `selected` for alterado
        }
    }
};
</script>